package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.AlignItems.CENTER
import com.downdogapp.Border.NONE
import com.downdogapp.FontWeight.BOLD
import com.downdogapp.FontWeight.MEDIUM
import com.downdogapp.JustifyContent.SPACE_BETWEEN
import com.downdogapp.Size.AUTO
import com.downdogapp.Size.Companion
import com.downdogapp.Size.Companion.px
import com.downdogapp.client.Strings
import com.downdogapp.client.controllers.ChallengeEnrollViewController
import com.downdogapp.client.displayName
import com.downdogapp.client.singleton.App
import com.downdogapp.client.widget.*
import com.downdogapp.client.widget.ScreenWidth.PHONE
import kotlinx.dom.clear
import org.w3c.dom.HTMLDivElement
import org.w3c.dom.HTMLElement

class ChallengeEnrollView(private val title: String,
                          subtitle: String,
                          buttonText: String,
                          defaultDailyEmailNotifications: Boolean,
                          defaultDailyPushNotifications: Boolean,
                          defaultChallengeUpdateEmails: Boolean,
                          private val controller: ChallengeEnrollViewController) : TopLevelView() {

  private var container: HTMLDivElement
  private var emailNotificationsToggle: Toggle
  private var challengeUpdateEmailsToggle: Toggle

  private var dailyEmailNotifications = defaultDailyEmailNotifications
  private var dailyPushNotifications = defaultDailyPushNotifications
  private var challengeUpdateEmails = defaultChallengeUpdateEmails

  override var root: HTMLElement =
    controllerView {
      background(blur = true)

      foreground {
        centerHorizontally {
          container = verticalFlexBox {
            screenWidthDependent { screendWidth ->
              width = px(if (screendWidth == PHONE) 330 else 500)
            }

            div {
              textAlign = TextAlign.CENTER
              marginTop = Companion.px(48)
              width = Companion.px(300)
              marginHorizontal = AUTO
              label(
                text = this@ChallengeEnrollView.title,
                fontSize = 26,
                fontWeight = MEDIUM
              ) {
                screenWidthDependent { screenWidth ->
                  fontSize = Companion.px(if (screenWidth == PHONE) 18 else 26)
                }
              }
            }

            div {
              textAlign = TextAlign.CENTER
              screenWidthDependent { screenWidth ->
                marginTop = Companion.px(if (screenWidth == PHONE) 10 else 20)
              }
              width = Companion.px(300)
              marginHorizontal = AUTO
              label(fontSize = 18) {
                innerHTML = subtitle.replace("\n", "<br>")
                screenWidthDependent { screenWidth ->
                  fontSize = Companion.px(if (screenWidth == PHONE) 14 else 18)
                }
              }
            }

            verticalFlexBox {
              paddingLeft = HORIZONTAL_CONTENT_GUTTER_PX
              paddingRight = HORIZONTAL_CONTENT_GUTTER_PX

              screenWidthDependent { screenWidth ->
                marginTop = Companion.px(if (screenWidth == PHONE) 30 else 50)
              }

              label(fontSize = 22) {
                textContent = Strings.CHALLENGE_ENROLL_DAILY_REMINDERS_SUBHEADER
                fontWeight = MEDIUM

                screenWidthDependent { screenWidth ->
                  fontSize = Companion.px(if (screenWidth == PHONE) 16 else 22)
                }
              }

              label(fontSize = 18) {
                textContent = Strings.CHALLENGE_ENROLL_DAILY_REMINDERS_SUBTEXT

                screenWidthDependent { screenWidth ->
                  fontSize = Companion.px(if (screenWidth == PHONE) 14 else 18)
                }
              }
            }

            horizontalFlexBox(verticalAlign = CENTER, horizontalJustify = SPACE_BETWEEN) {
              paddingLeft = HORIZONTAL_CONTENT_GUTTER_PX
              paddingRight = HORIZONTAL_CONTENT_GUTTER_PX

              marginTop = px(0)

              label(fontSize = 18) {
                textContent = Strings.CHALLENGE_EMAIL_NOTIFICATIONS_TEXT
                screenWidthDependent { screenWidth ->
                  fontSize = Companion.px(if (screenWidth == PHONE) 14 else 18)
                }
              }

              emailNotificationsToggle = toggle(
                getValue = { dailyEmailNotifications },
                onValueChanged = { dailyEmailNotifications = !dailyEmailNotifications }
              )
            }

            horizontalFlexBox(verticalAlign = CENTER, horizontalJustify = SPACE_BETWEEN) {
              paddingLeft = HORIZONTAL_CONTENT_GUTTER_PX
              paddingRight = HORIZONTAL_CONTENT_GUTTER_PX

              label(fontSize = 18) {
                textContent = Strings.CHALLENGE_PUSH_NOTIFICATIONS_TEXT
                screenWidthDependent { screenWidth ->
                  fontSize = Companion.px(if (screenWidth == PHONE) 14 else 18)
                }
              }

              toggle(
                getValue = { dailyPushNotifications },
                onValueChanged = { dailyPushNotifications = !dailyPushNotifications }
              )
            }

            verticalFlexBox {
              paddingLeft = HORIZONTAL_CONTENT_GUTTER_PX
              paddingRight = HORIZONTAL_CONTENT_GUTTER_PX

              screenWidthDependent { screenWidth ->
                marginTop = Companion.px(if (screenWidth == PHONE) 10 else 20)
              }

              label(fontSize = 22) {
                textContent = Strings.CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBHEADER
                fontWeight = MEDIUM

                screenWidthDependent { screenWidth ->
                  fontSize = Companion.px(if (screenWidth == PHONE) 16 else 22)
                }
              }

              label(fontSize = 18) {
                textContent = Strings.CHALLENGE_ENROLL_CHALLENGE_UPDATES_SUBTEXT

                screenWidthDependent { screenWidth ->
                  fontSize = Companion.px(if (screenWidth == PHONE) 14 else 18)
                }
              }
            }

            horizontalFlexBox(verticalAlign = CENTER, horizontalJustify = SPACE_BETWEEN) {
              paddingLeft = HORIZONTAL_CONTENT_GUTTER_PX
              paddingRight = HORIZONTAL_CONTENT_GUTTER_PX

              marginTop = px(0)

              label(fontSize = 18) {
                textContent = Strings.CHALLENGE_EMAIL_UPDATES_TEXT
                screenWidthDependent { screenWidth ->
                  fontSize = Companion.px(if (screenWidth == PHONE) 14 else 18)
                }
              }

              challengeUpdateEmailsToggle = toggle(
                getValue = { challengeUpdateEmails },
                onValueChanged = { challengeUpdateEmails = !challengeUpdateEmails }
              )
            }

            div {
              width = Companion.percent(100)
              div {
                paddingLeft = HORIZONTAL_CONTENT_GUTTER_PX
                paddingRight = HORIZONTAL_CONTENT_GUTTER_PX

                button {
                  screenWidthDependent { screenWidth ->
                    height = if (screenWidth == PHONE) Companion.px(50) else ROUNDED_TEXT_BUTTON_HEIGHT_PX
                    fontSize = Companion.px(if (screenWidth == PHONE) 15 else 19)
                    marginTop = Companion.px(if (screenWidth == PHONE) 10 else 35)
                  }
                  textContent = buttonText
                  width = Companion.percent(100)

                  borderRadius = ROUNDED_TEXT_BUTTON_HEIGHT_PX / 2
                  border = NONE

                  fontFamily = FONT_FAMILY
                  fontWeight = BOLD

                  bgColor = Color.DOWN_DOG_BLUE
                  txtColor = Color.WHITE

                  onClick {
                    spinnerShowing = true
                    controller.enroll(
                      dailyEmailNotifications = dailyEmailNotifications,
                      dailyPushNotifications = dailyPushNotifications,
                      challengeUpdateEmails = challengeUpdateEmails
                    ) { message ->
                      spinnerShowing = false
                      onEnrolled(message)
                    }
                  }
                }
              }
            }

            centerHorizontally {
              marginTop = px(25)
              label(fontSize = 24, fontWeight = MEDIUM, text = Strings.CHALLENGE_FAQ_TITLE) {
                screenWidthDependent { screenWidth ->
                  fontSize = Companion.px(if (screenWidth == PHONE) 18 else 24)
                }
              }
            }

            verticalFlexBox {
              marginTop = px(10)
              paddingBottom = px(30)

              val pairs = listOf(
                Strings.CHALLENGE_FAQ_Q1 to Strings.CHALLENGE_FAQ_A1,
                Strings.CHALLENGE_FAQ_Q2 to Strings.CHALLENGE_FAQ_A2,
                Strings.CHALLENGE_FAQ_Q3 to Strings.CHALLENGE_FAQ_A3,
                Strings.CHALLENGE_FAQ_Q4 to Strings.CHALLENGE_FAQ_A4,
                Strings.CHALLENGE_FAQ_Q5 to Strings.CHALLENGE_FAQ_A5,
                Strings.CHALLENGE_FAQ_Q6 to Strings.CHALLENGE_FAQ_A6
              )

              for (pair in pairs) {
                verticalFlexBox {
                  marginTop = px(10)

                  label(fontSize = 20, fontWeight = FontWeight.REGULAR, text = pair.first) {
                    screenWidthDependent { screenWidth ->
                      fontSize = Companion.px(if (screenWidth == PHONE) 16 else 20)
                    }
                  }
                  label(fontSize = 16, fontWeight = FontWeight.LIGHT, text = pair.second) {
                    screenWidthDependent { screenWidth ->
                      fontSize = Companion.px(if (screenWidth == PHONE) 12 else 16)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }

  fun disableEmailNotifications() {
    dailyEmailNotifications = false
    challengeUpdateEmails = false
    emailNotificationsToggle.refresh()
    challengeUpdateEmailsToggle.refresh()
  }

  private fun onEnrolled(message: String) {
    container.apply {
      clear()

      div {
        textAlign = TextAlign.LEFT
        marginTop = Companion.px(64)
        width = Companion.px(300)
        marginHorizontal = AUTO
        label(
          text = this@ChallengeEnrollView.title,
          fontSize = 24,
          fontWeight = MEDIUM
        ) {
          screenWidthDependent { screenWidth ->
            fontSize = Companion.px(if (screenWidth == PHONE) 18 else 24)
          }
        }
      }

      div {
        textAlign = TextAlign.LEFT
        screenWidthDependent { screenWidth ->
          marginTop = Companion.px(if (screenWidth == PHONE) 10 else 30)
        }
        width = Companion.px(300)
        marginHorizontal = AUTO
        label(fontSize = 18) {
          innerHTML = message.replace("\n", "<br>")
          screenWidthDependent { screenWidth ->
            fontSize = Companion.px(if (screenWidth == PHONE) 14 else 18)
          }
        }
      }

      if (dailyPushNotifications) {
        div {
          textAlign = TextAlign.LEFT
          screenWidthDependent { screenWidth ->
            marginTop = Companion.px(if (screenWidth == PHONE) 10 else 30)
          }
          width = Companion.px(300)
          marginHorizontal = AUTO
          label(fontSize = 18) {
            marginBottom = px(15)
            innerHTML = Strings.ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_PROMPT.replace("\n", "<br>")
            screenWidthDependent { screenWidth ->
              fontSize = Companion.px(if (screenWidth == PHONE) 14 else 18)
            }
          }
        }

        div {
          textAlign = TextAlign.LEFT
          screenWidthDependent { screenWidth ->
            marginTop = Companion.px(if (screenWidth == PHONE) 10 else 30)
          }
          width = Companion.px(300)
          marginHorizontal = AUTO


          Strings
            .ENROLL_CHALLENGE_ENABLE_PUSH_NOTIFICATIONS_INSTRUCTIONS(App.appType.displayName)
            .split("\n")
            .filterNot { it.isBlank() }
            .forEach {
              div {
                label(fontSize = 18) {
                  innerHTML = it.trim()
                  screenWidthDependent { screenWidth ->
                    fontSize = Companion.px(if (screenWidth == PHONE) 14 else 18)
                  }
                }
              }
            }
        }
      }
    }
  }
}
